/**
 * @generated SignedSource<<91a37aab84d459dd9c45daf775412094>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type GoalHeaderRefreshedQuery$variables = {
  connectedUpdatesEnabled: boolean;
  goalUpdateDraftsEnabled: boolean;
  key: string;
  trackViewEvent?: TrackViewEvent | null;
};
export type GoalHeaderRefreshedQuery$data = {
  readonly goal: {
    readonly ari: string;
    readonly " $fragmentSpreads": FragmentRefs<"GoalHeader">;
  } | null;
};
export type GoalHeaderRefreshedQuery = {
  response: GoalHeaderRefreshedQuery$data;
  variables: GoalHeaderRefreshedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connectedUpdatesEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalUpdateDraftsEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v4 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "ari"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "value"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "messageId"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "LocalizationField"
},
v13 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v10/*: any*/),
      "type": "GoalTypeCustomName"
    },
    (v12/*: any*/)
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "kind"
},
v15 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v10/*: any*/),
      "type": "GoalTypeCustomNamePlural"
    },
    (v12/*: any*/)
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "state"
},
v17 = {
  "kind": "ScalarField",
  "name": "key"
},
v18 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "score"
},
v20 = [
  (v9/*: any*/),
  (v19/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v22 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v23 = {
  "kind": "ScalarField",
  "name": "watching"
},
v24 = {
  "kind": "ScalarField",
  "name": "canWatchGoal"
},
v25 = {
  "kind": "ScalarField",
  "name": "archived"
},
v26 = {
  "concreteType": "GoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v7/*: any*/)
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v28 = {
  "kind": "ScalarField",
  "name": "type"
},
v29 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v28/*: any*/)
  ]
},
v30 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v31 = [
  (v11/*: any*/)
],
v32 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v31/*: any*/)
},
v33 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    (v32/*: any*/),
    (v9/*: any*/),
    (v19/*: any*/)
  ]
},
v34 = [
  (v30/*: any*/),
  (v32/*: any*/),
  (v19/*: any*/),
  (v9/*: any*/),
  (v33/*: any*/)
],
v35 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v34/*: any*/)
},
v36 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v37 = {
  "kind": "ScalarField",
  "name": "label"
},
v38 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v39 = {
  "alias": "tooltip",
  "args": (v38/*: any*/),
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(longFormat:true)"
},
v40 = {
  "alias": "localizedTooltip",
  "args": (v38/*: any*/),
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": "localizedLabel(longFormat:true)"
},
v41 = {
  "kind": "ScalarField",
  "name": "overdue"
},
v42 = [
  (v36/*: any*/),
  (v37/*: any*/),
  (v32/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/)
],
v43 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v42/*: any*/)
},
v44 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v45 = {
  "kind": "ScalarField",
  "name": "picture"
},
v46 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v47 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v46/*: any*/)
  ]
},
v48 = [
  (v9/*: any*/),
  (v7/*: any*/)
],
v49 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v51 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v52 = {
  "kind": "ScalarField",
  "name": "subType"
},
v53 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  },
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v54 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v55 = {
  "concreteType": "ProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        {
          "concreteType": "ProjectPhaseDetails",
          "kind": "LinkedField",
          "name": "newPhase",
          "plural": false,
          "selections": [
            {
              "alias": "_id",
              "kind": "ScalarField",
              "name": "id"
            }
          ]
        },
        {
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v44/*: any*/),
            (v47/*: any*/)
          ]
        },
        (v17/*: any*/),
        (v6/*: any*/),
        (v22/*: any*/),
        {
          "kind": "ScalarField",
          "name": "private"
        },
        {
          "concreteType": "IconURIs",
          "kind": "LinkedField",
          "name": "iconUrl",
          "plural": false,
          "selections": [
            {
              "concreteType": "ThemeURIs",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "light"
                },
                {
                  "kind": "ScalarField",
                  "name": "dark"
                },
                {
                  "kind": "ScalarField",
                  "name": "transparent"
                }
              ]
            }
          ]
        },
        (v43/*: any*/),
        {
          "concreteType": "ProjectState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": [
            (v37/*: any*/),
            (v32/*: any*/),
            (v9/*: any*/),
            {
              "concreteType": "CompletionProjectState",
              "kind": "LinkedField",
              "name": "atCompletionState",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v37/*: any*/),
                (v32/*: any*/)
              ]
            }
          ]
        },
        (v25/*: any*/),
        {
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "concreteType": "UserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v44/*: any*/),
                    (v7/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    (v54/*: any*/)
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "count"
},
v57 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v58 = [
  (v6/*: any*/),
  (v45/*: any*/)
],
v59 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_DESC"
    ]
  }
],
v60 = {
  "kind": "ScalarField",
  "name": "time"
},
v61 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v58/*: any*/)
},
v62 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v63 = [
  (v7/*: any*/)
],
v64 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v20/*: any*/)
},
v65 = {
  "kind": "LinkedField",
  "name": "origin",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "GoalUpdate",
          "kind": "LinkedField",
          "name": "goalUpdate",
          "plural": false,
          "selections": [
            (v62/*: any*/),
            {
              "concreteType": "Goal",
              "kind": "LinkedField",
              "name": "goal",
              "plural": false,
              "selections": (v63/*: any*/)
            },
            (v64/*: any*/),
            (v7/*: any*/)
          ]
        }
      ],
      "type": "FromGoalUpdate"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v62/*: any*/)
      ],
      "type": "FromMetricCreation"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "updateDate"
        }
      ],
      "type": "FromMetricUpdate"
    }
  ]
},
v66 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v67 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v68 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    (v67/*: any*/)
  ]
},
v69 = {
  "args": (v59/*: any*/),
  "concreteType": "MetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v5/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v9/*: any*/),
            (v60/*: any*/),
            (v61/*: any*/),
            (v65/*: any*/),
            (v8/*: any*/)
          ]
        },
        (v66/*: any*/)
      ]
    },
    (v68/*: any*/),
    (v54/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
},
v70 = {
  "args": (v59/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v71 = {
  "kind": "ScalarField",
  "name": "source"
},
v72 = [
  (v60/*: any*/),
  (v7/*: any*/)
],
v73 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v72/*: any*/)
},
v74 = {
  "kind": "ScalarField",
  "name": "end"
},
v75 = {
  "concreteType": "TargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v74/*: any*/)
  ]
},
v76 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v75/*: any*/)
  ]
},
v77 = {
  "kind": "ScalarField",
  "name": "variance"
},
v78 = {
  "args": (v59/*: any*/),
  "concreteType": "MetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v60/*: any*/)
          ]
        },
        {
          "concreteType": "MetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            (v76/*: any*/),
            (v9/*: any*/)
          ]
        },
        (v77/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_DESC\"])"
},
v79 = {
  "concreteType": "MetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v48/*: any*/)
    },
    (v77/*: any*/)
  ]
},
v80 = [
  (v28/*: any*/),
  (v27/*: any*/)
],
v81 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v80/*: any*/)
},
v82 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v27/*: any*/)
  ]
},
v83 = [
  (v56/*: any*/)
],
v84 = {
  "alias": "successMeasureCount",
  "concreteType": "GoalConnection",
  "kind": "LinkedField",
  "name": "successMeasures",
  "plural": false,
  "selections": (v83/*: any*/)
},
v85 = [
  (v13/*: any*/),
  (v15/*: any*/),
  (v7/*: any*/)
],
v86 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v67/*: any*/)
  ]
},
v87 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v88 = {
  "concreteType": "WorkspaceAIConfig",
  "kind": "LinkedField",
  "name": "aiConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    }
  ]
},
v89 = {
  "concreteType": "MetricTargetPeriodConnection",
  "kind": "LinkedField",
  "name": "metricTargetPeriods",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricTargetPeriodEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricTargetPeriod",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "TargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TargetDateRange",
                  "kind": "LinkedField",
                  "name": "dateRange",
                  "plural": false,
                  "selections": [
                    (v74/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "start"
                    }
                  ]
                }
              ]
            },
            (v9/*: any*/),
            (v79/*: any*/)
          ]
        }
      ]
    }
  ]
},
v90 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v91 = {
  "kind": "ScalarField",
  "name": "summary"
},
v92 = {
  "kind": "ScalarField",
  "name": "title"
},
v93 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v92/*: any*/),
    (v91/*: any*/),
    (v7/*: any*/)
  ]
},
v94 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v95 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v90/*: any*/),
            (v5/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v62/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v45/*: any*/),
                    (v6/*: any*/),
                    (v94/*: any*/),
                    (v46/*: any*/)
                  ]
                },
                (v7/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v54/*: any*/)
  ]
},
v96 = [
  (v6/*: any*/)
],
v97 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v98 = {
  "concreteType": "UpdateGenerationSettings",
  "kind": "LinkedField",
  "name": "updateGenerationSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "templateKey"
    }
  ]
},
v99 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v100 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v101 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v102 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v103 = [
  {
    "concreteType": "ConnectedUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "sourceGoal",
        "plural": false,
        "selections": (v63/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalHeaderRefreshedQuery",
    "selections": [
      {
        "alias": "goal",
        "args": (v4/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "GoalHeader"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalHeaderRefreshedQuery",
    "selections": [
      {
        "alias": "goal",
        "args": (v4/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "concreteType": "GoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v7/*: any*/),
              (v14/*: any*/),
              {
                "concreteType": "GoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v15/*: any*/),
                  (v7/*: any*/),
                  (v16/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "parentGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          {
            "concreteType": "GoalState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "CompletionGoalState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": (v20/*: any*/)
              }
            ]
          },
          (v21/*: any*/),
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              }
            ]
          },
          (v25/*: any*/),
          {
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v6/*: any*/),
              (v22/*: any*/),
              (v5/*: any*/)
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v7/*: any*/),
                      (v26/*: any*/),
                      (v29/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canAddLinkedProjects"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveLinkedProjects"
                          }
                        ]
                      },
                      (v22/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v6/*: any*/),
                      (v35/*: any*/),
                      (v43/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/),
                          (v47/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/),
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v28/*: any*/),
                                      (v52/*: any*/),
                                      (v7/*: any*/),
                                      (v25/*: any*/)
                                    ]
                                  },
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "args": (v53/*: any*/),
                        "concreteType": "ProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          (v55/*: any*/),
                          (v54/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      }
                    ]
                  }
                ]
              },
              (v56/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": "connectionId",
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "args": (v57/*: any*/),
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v5/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/),
                      (v35/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": (v58/*: any*/)
                          },
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v28/*: any*/),
                                      (v52/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v69/*: any*/),
                                      (v70/*: any*/),
                                      (v25/*: any*/),
                                      (v71/*: any*/),
                                      (v73/*: any*/),
                                      (v5/*: any*/),
                                      (v22/*: any*/)
                                    ]
                                  },
                                  (v51/*: any*/),
                                  (v49/*: any*/),
                                  (v7/*: any*/),
                                  (v78/*: any*/),
                                  {
                                    "concreteType": "MetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "MetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "MetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v76/*: any*/),
                                              (v9/*: any*/),
                                              (v79/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v50/*: any*/),
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v21/*: any*/),
                      (v81/*: any*/),
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "subGoals",
                        "plural": false,
                        "selections": [
                          (v56/*: any*/),
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v26/*: any*/),
                                  (v25/*: any*/),
                                  (v7/*: any*/),
                                  (v82/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v84/*: any*/),
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "successMeasure",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v15/*: any*/),
                              (v7/*: any*/),
                              (v16/*: any*/)
                            ]
                          },
                          (v7/*: any*/),
                          (v14/*: any*/),
                          (v13/*: any*/),
                          (v15/*: any*/)
                        ]
                      },
                      {
                        "args": (v57/*: any*/),
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "successMeasures",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v81/*: any*/),
                                  (v25/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "concreteType": "GoalType",
                                    "kind": "LinkedField",
                                    "name": "goalType",
                                    "plural": false,
                                    "selections": (v85/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          (v86/*: any*/)
                        ],
                        "storageKey": "successMeasures(first:50)"
                      },
                      (v87/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "parentGoal",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v8/*: any*/)
                ]
              },
              (v86/*: any*/)
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "kind": "ScalarField",
            "name": "userUpdateCount"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "learningsCount"
          },
          {
            "kind": "ScalarField",
            "name": "risksCount"
          },
          {
            "kind": "ScalarField",
            "name": "decisionsCount"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v7/*: any*/),
              (v88/*: any*/),
              {
                "concreteType": "UserCapabilities",
                "kind": "LinkedField",
                "name": "currentUserAppCapabilities",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Capability",
                    "kind": "LinkedField",
                    "name": "capabilities",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "capability"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "capabilityContainer"
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v81/*: any*/),
          {
            "concreteType": "MetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "MetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "MetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "Metric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v28/*: any*/),
                          (v52/*: any*/),
                          (v25/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "externalEntityId"
                          },
                          (v69/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/),
                          {
                            "concreteType": "MetricValue",
                            "kind": "LinkedField",
                            "name": "latestValue",
                            "plural": false,
                            "selections": [
                              (v60/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          (v22/*: any*/)
                        ]
                      },
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v78/*: any*/),
                      (v89/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v84/*: any*/),
          (v87/*: any*/),
          {
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v72/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/),
              (v90/*: any*/),
              (v62/*: any*/),
              (v91/*: any*/),
              (v93/*: any*/)
            ]
          },
          (v95/*: any*/),
          {
            "concreteType": "GoalPhaseDetails",
            "kind": "LinkedField",
            "name": "phase",
            "plural": false,
            "selections": (v96/*: any*/)
          },
          (v97/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": (v83/*: any*/)
          },
          (v98/*: any*/),
          {
            "alias": "latestUpdates",
            "args": (v99/*: any*/),
            "concreteType": "GoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v62/*: any*/),
                      (v100/*: any*/),
                      (v101/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "updates(first:1)"
          },
          {
            "kind": "ScalarField",
            "name": "updateStreak"
          },
          {
            "args": (v102/*: any*/),
            "concreteType": "GoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      (v62/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v22/*: any*/),
                          {
                            "concreteType": "Workspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v7/*: any*/),
                              (v88/*: any*/)
                            ]
                          },
                          (v23/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v22/*: any*/)
                            ]
                          },
                          (v17/*: any*/),
                          (v6/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v62/*: any*/),
                              (v90/*: any*/),
                              (v91/*: any*/),
                              (v93/*: any*/)
                            ]
                          },
                          (v97/*: any*/),
                          (v29/*: any*/),
                          {
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": (v83/*: any*/)
                          },
                          (v84/*: any*/),
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v50/*: any*/),
                                      (v51/*: any*/),
                                      (v7/*: any*/),
                                      (v49/*: any*/),
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v6/*: any*/),
                                          (v28/*: any*/),
                                          (v52/*: any*/),
                                          (v25/*: any*/),
                                          (v71/*: any*/),
                                          (v73/*: any*/),
                                          (v69/*: any*/),
                                          (v70/*: any*/)
                                        ]
                                      },
                                      (v78/*: any*/),
                                      (v89/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": (v85/*: any*/)
                              },
                              (v7/*: any*/)
                            ]
                          },
                          (v21/*: any*/),
                          (v98/*: any*/),
                          (v54/*: any*/),
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": (v10/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/),
                          (v7/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v6/*: any*/),
                              (v94/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v100/*: any*/),
                      (v101/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "GoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v60/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v6/*: any*/),
                                      (v28/*: any*/),
                                      (v52/*: any*/),
                                      (v25/*: any*/),
                                      {
                                        "args": (v59/*: any*/),
                                        "concreteType": "MetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "MetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "MetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  (v5/*: any*/),
                                                  (v9/*: any*/),
                                                  (v60/*: any*/),
                                                  (v61/*: any*/),
                                                  (v65/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      },
                                      (v71/*: any*/),
                                      (v73/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v7/*: any*/),
                                      (v60/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v80/*: any*/)
                      },
                      (v64/*: any*/),
                      {
                        "args": (v57/*: any*/),
                        "concreteType": "GoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v82/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      (v95/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasConnectedUpdates"
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": (v96/*: any*/)
                          },
                          (v7/*: any*/)
                        ]
                      },
                      (v90/*: any*/),
                      {
                        "alias": "newGoalState",
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v30/*: any*/),
                          (v32/*: any*/),
                          (v19/*: any*/),
                          (v33/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": [
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v32/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v75/*: any*/)
                        ]
                      },
                      (v91/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          (v22/*: any*/),
                          (v92/*: any*/),
                          (v91/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v42/*: any*/)
                      },
                      {
                        "alias": "oldGoalState",
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v34/*: any*/)
                      },
                      {
                        "concreteType": "GoalPhaseDetails",
                        "kind": "LinkedField",
                        "name": "newPhase",
                        "plural": false,
                        "selections": (v96/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ],
                            "type": "ProjectUpdate"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ]
                  },
                  (v66/*: any*/)
                ]
              },
              (v68/*: any*/)
            ],
            "storageKey": "updates(first:30)"
          },
          {
            "args": (v102/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "args": (v53/*: any*/),
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              (v56/*: any*/),
              (v55/*: any*/),
              (v54/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          {
            "condition": "goalUpdateDraftsEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "DraftUpdate",
                "kind": "LinkedField",
                "name": "draftUpdate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "input"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "modifiedDate"
                  },
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "pii",
                        "plural": false,
                        "selections": [
                          (v46/*: any*/),
                          (v6/*: any*/),
                          (v45/*: any*/)
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  (v7/*: any*/),
                  (v54/*: any*/)
                ]
              }
            ]
          },
          (v54/*: any*/),
          {
            "condition": "connectedUpdatesEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "ConnectedUpdates",
                "kind": "LinkedField",
                "name": "connectedUpdates",
                "plural": false,
                "selections": [
                  {
                    "args": (v99/*: any*/),
                    "concreteType": "ConnectedUpdateConnection",
                    "kind": "LinkedField",
                    "name": "successMeasureUpdates",
                    "plural": false,
                    "selections": (v103/*: any*/),
                    "storageKey": "successMeasureUpdates(first:1)"
                  },
                  {
                    "args": (v99/*: any*/),
                    "concreteType": "ConnectedUpdateConnection",
                    "kind": "LinkedField",
                    "name": "subGoalUpdates",
                    "plural": false,
                    "selections": (v103/*: any*/),
                    "storageKey": "subGoalUpdates(first:1)"
                  },
                  {
                    "args": (v99/*: any*/),
                    "concreteType": "ConnectedUpdateConnection",
                    "kind": "LinkedField",
                    "name": "projectUpdates",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ConnectedUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "sourceProject",
                            "plural": false,
                            "selections": (v63/*: any*/)
                          }
                        ]
                      }
                    ],
                    "storageKey": "projectUpdates(first:1)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "93b3a842799dc569d1eb741f2c71b9c5",
    "id": null,
    "metadata": {},
    "name": "GoalHeaderRefreshedQuery",
    "operationKind": "query",
    "text": "query GoalHeaderRefreshedQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $goalUpdateDraftsEnabled: Boolean!\n  $connectedUpdatesEnabled: Boolean!\n) {\n  goal: goalByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    ari\n    ...GoalHeader\n    id\n  }\n}\n\nfragment ActivityHistorySection on Goal {\n  ...GoalComments\n}\n\nfragment AddToMissedUpdateMessage on Goal {\n  id\n  latestUpdates: updates(first: 1) {\n    edges {\n      node {\n        id\n        creationDate\n        missedUpdate\n        updateType\n      }\n    }\n  }\n}\n\nfragment ArchiveGoal_goalActions on Goal {\n  id\n  name\n  archived\n  parentGoal {\n    id\n    name\n  }\n  subGoals {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n  goalType {\n    kind\n    successMeasure {\n      ...goalTypeNamePlural\n      id\n    }\n    id\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment ChangeRollupTypePopup on Goal {\n  ...ChangeRollupTypeWarning\n  id\n  goalType {\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n  progress {\n    type\n  }\n  subGoals {\n    edges {\n      node {\n        goalType {\n          kind\n          id\n        }\n        archived\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        progress {\n          type\n        }\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment ChangeRollupTypeWarning on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  goalType {\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment CompactGoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment ContributingProjectsSummary on ProjectConnection {\n  edges {\n    node {\n      archived\n      owner {\n        aaid\n        id\n      }\n      members {\n        edges {\n          node {\n            aaid\n            id\n          }\n        }\n      }\n      state {\n        value\n      }\n      id\n    }\n  }\n}\n\nfragment DraftGoalUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment DueDateContext on Goal {\n  phase {\n    name\n  }\n  latestUpdateDate\n}\n\nfragment EditGoalProgressEditor on GoalUpdate {\n  creationDate\n  goal {\n    metricTargets {\n      edges {\n        node {\n          id\n          metric {\n            id\n          }\n          metricTargetPeriods {\n            edges {\n              node {\n                date {\n                  dateRange {\n                    start\n                  }\n                }\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            id\n          }\n        }\n        newValue {\n          value\n          time\n          id\n        }\n        oldValue {\n          time\n          id\n        }\n        newStartValue\n        newTargetValue\n      }\n    }\n  }\n}\n\nfragment EditGoalUpdate on GoalUpdate {\n  id\n  ari\n  uuid\n  creationDate\n  missedUpdate\n  hasConnectedUpdates\n  summary\n  newPhase {\n    name\n  }\n  newGoalState: newState {\n    score\n    value\n  }\n  newTargetDate\n  newTargetDateConfidence\n  notes {\n    summary\n    title\n    uuid\n    id\n  }\n  goal {\n    ...GoalDraftWithRovoField\n    id\n    ari\n    key\n    uuid\n    workspace {\n      uuid\n      id\n      aiConfig {\n        enabled\n      }\n    }\n    latestUserUpdate {\n      editDate\n      creationDate\n      summary\n      notes {\n        title\n        summary\n        id\n      }\n      id\n    }\n    metricTargets {\n      edges {\n        node {\n          metric {\n            id\n            archived\n          }\n          id\n        }\n      }\n    }\n    parentGoal {\n      uuid\n      id\n    }\n    ...SuccessMeasureChart\n  }\n  ...EditGoalProgressEditor\n}\n\nfragment EditableGoalUpdateCard on GoalUpdate {\n  id\n  goal {\n    id\n  }\n  creationDate\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...GoalUpdateCard\n  ...EditGoalUpdate\n}\n\nfragment EmptyStateNoUpdates on Goal {\n  watching\n  canPostUpdate\n}\n\nfragment GoalAboutTab on Goal {\n  id\n  description\n  goalType {\n    kind\n    id\n  }\n  parentGoal {\n    uuid\n    id\n  }\n  capabilities {\n    canEditMetadata\n  }\n  ...GoalDescription\n  ...SuccessMeasuresSectionFragment\n  ...SuccessMeasureMetricSection\n  ...ActivityHistorySection\n}\n\nfragment GoalActions on Goal {\n  id\n  ari\n  name\n  capabilities {\n    canArchiveGoal\n  }\n  ...ArchiveGoal_goalActions\n}\n\nfragment GoalComments on Goal {\n  id\n  ari\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalDatePicker on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  targetDate\n  targetDateConfidence\n}\n\nfragment GoalDescription on Goal {\n  id\n  uuid\n  ari\n  description\n  descriptionWhy\n  descriptionMeasurement\n  canPostUpdate\n  workspace {\n    uuid\n    id\n  }\n  goalType {\n    kind\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        __typename\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment GoalDraftWithRovoField on Goal {\n  ...GoalUpdateComposerDraftWithRovoButton\n}\n\nfragment GoalDraftWithRovoField_ComposerButton on Goal {\n  ...GoalUpdateComposerDraftWithRovoButton\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchGoal\n  }\n}\n\nfragment GoalHeader on Goal {\n  ...GoalTitle\n  ...GoalHeaderBreadcrumbs\n  ...PlatformGoalIcon\n  ...GoalMetaActions\n  ...GoalTabsRefreshed_4sf9XQ\n}\n\nfragment GoalHeaderBreadcrumbs on Goal {\n  parentGoals {\n    edges {\n      node {\n        id\n        key\n        name\n      }\n    }\n  }\n  name\n  key\n}\n\nfragment GoalMetaActions on Goal {\n  key\n  ...GoalStateAndTargetDate\n  ...GoalFollowButton\n  ...GoalActions\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProgressEditor on Goal {\n  id\n  progress {\n    percentage\n    type\n  }\n  subGoals {\n    count\n  }\n  latestUserUpdate {\n    metricUpdate {\n      edges {\n        node {\n          newValue {\n            time\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            value\n            id\n          }\n        }\n        metricTargetPeriods {\n          edges {\n            node {\n              date {\n                dateRange {\n                  start\n                }\n              }\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProjects on Goal {\n  id\n  archived\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n    ...ProjectTable\n    ...ContributingProjectsSummary\n  }\n  ...LinkGoalProject\n}\n\nfragment GoalProjectsTab on Goal {\n  goalType {\n    kind\n    id\n  }\n  projects(tql: \"archived = false\", first: 200) {\n    count\n  }\n  subGoals {\n    count\n  }\n  ...GoalProjects\n  ...GoalSubGoals\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStateAndDatePicker_capabilities on TownsquareGoalCapabilities {\n  canEditTargetDate\n  ...GoalStatePickerWrapper\n}\n\nfragment GoalStateAndDatePicker_goal on Goal {\n  ...GoalDraftWithRovoField_ComposerButton\n}\n\nfragment GoalStateAndTargetDate on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n    score\n    atCompletionState {\n      value\n      score\n    }\n  }\n  ...GoalDatePicker\n}\n\nfragment GoalStatePickerWrapper on TownsquareGoalCapabilities {\n  ...GoalStatePicker_statusCapabilities\n}\n\nfragment GoalStatePicker_statusCapabilities on TownsquareGoalCapabilities {\n  canEditStatus\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newGoalState: newState {\n    ...GoalState\n  }\n  oldGoalState: oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalSubGoals on Goal {\n  id\n  ari\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        capabilities {\n          canAddLinkedProjects\n          canRemoveLinkedProjects\n        }\n        ...GoalSummaryPanel\n        ...CompactGoalSummaryPanel\n        ...GoalProjects\n      }\n    }\n  }\n}\n\nfragment GoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment GoalTabsRefreshed_4sf9XQ on Goal {\n  key\n  watching\n  userUpdateCount\n  canEditUpdate\n  learningsCount\n  risksCount\n  decisionsCount\n  ...GoalAboutTab\n  ...GoalUpdatesTab_4sf9XQ\n  ...GoalProjectsTab\n  ...useUserHasCapabilitiesFromGoal\n}\n\nfragment GoalTitle on Goal {\n  name\n  id\n  goalType {\n    ...goalTypeName\n    id\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  ari\n  uuid\n  hasConnectedUpdates\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateMetricChart\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  creationDate\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          time\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  newState {\n    value\n  }\n  bundledUpdates(first: 50) {\n    edges {\n      goal {\n        progress {\n          percentage\n        }\n        id\n      }\n    }\n  }\n  goal {\n    id\n    progress {\n      percentage\n      type\n    }\n    subGoals {\n      count\n    }\n    successMeasureCount: successMeasures {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n    ...MetricChart\n    ...useRollupSourceName\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateComposerDraftWithRovoButton on Goal {\n  ari\n  updateGenerationSettings {\n    templateKey\n  }\n}\n\nfragment GoalUpdateComposer_4sf9XQ on Goal {\n  ...DueDateContext\n  ...NewGoalUpdate_okloi\n  ...AddToMissedUpdateMessage\n  state @include(if: $goalUpdateDraftsEnabled) {\n    value\n    score\n  }\n  targetDate @include(if: $goalUpdateDraftsEnabled)\n  targetDateConfidence @include(if: $goalUpdateDraftsEnabled)\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    input\n    ...DraftGoalUpdate\n    id\n  }\n  metricTargets @include(if: $goalUpdateDraftsEnabled) {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        metric {\n          type\n          subType\n          id\n        }\n      }\n    }\n  }\n  latestUserUpdate {\n    id\n  }\n  id\n  ari\n  uuid\n  workspace {\n    uuid\n    aiConfig {\n      enabled\n    }\n    id\n  }\n  connectedUpdates @include(if: $connectedUpdatesEnabled) {\n    successMeasureUpdates(first: 1) {\n      edges {\n        sourceGoal {\n          id\n        }\n      }\n    }\n    subGoalUpdates(first: 1) {\n      edges {\n        sourceGoal {\n          id\n        }\n      }\n    }\n    projectUpdates(first: 1) {\n      edges {\n        sourceProject {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  missedUpdate\n  creationDate\n  editDate\n  metricUpdate {\n    edges {\n      node {\n        newValue {\n          time\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateMetricChart on GoalUpdate {\n  creationDate\n  goal {\n    id\n    targetDate\n    metricTargets {\n      edges {\n        node {\n          targetValue\n          id\n        }\n      }\n    }\n  }\n  newDueDate {\n    dateRange {\n      end\n    }\n  }\n  newState {\n    value\n    score\n  }\n  metricUpdate {\n    edges {\n      node {\n        newTargetValue\n        metric {\n          name\n          type\n          subType\n          archived\n          values(first: 100, sort: [TIME_DESC]) {\n            edges {\n              node {\n                id\n                ari\n                value\n                time\n                creator {\n                  name\n                  picture\n                }\n                origin {\n                  __typename\n                  ... on FromGoalUpdate {\n                    goalUpdate {\n                      creationDate\n                      goal {\n                        id\n                      }\n                      newState {\n                        value\n                        score\n                      }\n                      id\n                    }\n                  }\n                  ... on FromMetricCreation {\n                    creationDate\n                  }\n                  ... on FromMetricUpdate {\n                    updateDate\n                  }\n                }\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newGoalState: newState {\n    value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalUpdatesTab_4sf9XQ on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  targetDate\n  targetDateConfidence\n  ...GoalUpdateComposer_4sf9XQ\n  ...UpdatesList\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    id\n  }\n}\n\nfragment LinkGoalProject on Goal {\n  id\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ...useRollupSourceName\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment NewGoalUpdate_okloi on Goal {\n  id\n  uuid\n  ari\n  key\n  workspace {\n    uuid\n    id\n  }\n  phase {\n    name\n  }\n  state {\n    value\n    score\n  }\n  targetDate @include(if: $goalUpdateDraftsEnabled)\n  targetDateConfidence @include(if: $goalUpdateDraftsEnabled)\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    input\n    ...DraftGoalUpdate\n    id\n  }\n  watchers {\n    count\n  }\n  latestUserUpdate {\n    id\n    editDate\n    creationDate\n    summary\n    metricUpdate @include(if: $goalUpdateDraftsEnabled) {\n      edges {\n        node {\n          newValue {\n            time\n            id\n          }\n        }\n      }\n    }\n    notes {\n      title\n      summary\n      id\n    }\n  }\n  progress {\n    type\n    percentage @include(if: $goalUpdateDraftsEnabled)\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue @include(if: $goalUpdateDraftsEnabled) {\n          value\n          id\n        }\n        metric @include(if: $goalUpdateDraftsEnabled) {\n          archived\n          latestValue {\n            value\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n  parentGoal {\n    uuid\n    id\n  }\n  ...hasMetric\n  ...GoalProgressEditor\n  ...SuccessMeasureChart\n  capabilities {\n    ...GoalStateAndDatePicker_capabilities\n  }\n  ...GoalDraftWithRovoField\n  ...GoalStateAndDatePicker_goal\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTable on ProjectConnection {\n  edges {\n    node {\n      id\n      newPhase {\n        _id: id\n      }\n      ...ProjectTableRow\n      ...ProjectTableCompactRow\n    }\n  }\n}\n\nfragment ProjectTableCompactRow on Project {\n  id\n  key\n  name\n  state {\n    ...ProjectState\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectTableRow on Project {\n  id\n  owner {\n    id\n    ...UserAvatar_2aqwkz\n  }\n  ...ProjectName_data\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment SuccessMeasureCardFragment on Goal {\n  ari\n  key\n  name\n  state {\n    ...GoalState\n    value\n  }\n  owner {\n    pii {\n      name\n      picture\n    }\n    id\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          name\n          id\n        }\n        targetValue\n        snapshotValue {\n          value\n          id\n        }\n        id\n      }\n    }\n  }\n  ...SuccessMeasureChart\n  ...metricInfoSectionContent\n  id\n}\n\nfragment SuccessMeasureChart on Goal {\n  id\n  state {\n    value\n  }\n  metricTargets {\n    edges {\n      node {\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          values(first: 100, sort: [TIME_DESC]) {\n            edges {\n              node {\n                id\n                ari\n                canDelete\n                value\n                time\n                creator {\n                  name\n                  picture\n                }\n                origin {\n                  __typename\n                  ... on FromGoalUpdate {\n                    goalUpdate {\n                      creationDate\n                      goal {\n                        id\n                      }\n                      newState {\n                        value\n                        score\n                      }\n                      id\n                    }\n                  }\n                  ... on FromMetricCreation {\n                    creationDate\n                  }\n                  ... on FromMetricUpdate {\n                    updateDate\n                  }\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n        }\n        metricValues(first: 100, sort: [TIME_DESC]) {\n          edges {\n            node {\n              id\n              time\n            }\n            metricTargetPeriod {\n              date {\n                dateRange {\n                  end\n                }\n              }\n              value\n            }\n            variance\n          }\n        }\n        metricTargetPeriods {\n          edges {\n            node {\n              date {\n                dateRange {\n                  end\n                }\n              }\n              value\n              latestValue {\n                node {\n                  value\n                  id\n                }\n                variance\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  targetDate\n}\n\nfragment SuccessMeasureMetricSection on Goal {\n  id\n  key\n  ari\n  metricTargets {\n    edges {\n      node {\n        __typename\n        id\n        ari\n        metric {\n          id\n          ari\n          name\n          type\n          subType\n          archived\n          externalEntityId\n        }\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n      }\n    }\n  }\n  ...SuccessMeasureMetricSectionEmptyState\n  ...SuccessMeasureChart\n  ...metricInfoSectionContent\n  ...GoalProgressEditor\n}\n\nfragment SuccessMeasureMetricSectionEmptyState on Goal {\n  ari\n}\n\nfragment SuccessMeasuresSectionFragment on Goal {\n  ari\n  archived\n  goalType {\n    kind\n    successMeasure {\n      state\n      ari\n      ...goalTypeName\n      ...goalTypeNamePlural\n      id\n    }\n    ...goalTypeName\n    id\n  }\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      __typename\n      node {\n        id\n        archived\n        ...SuccessMeasureCardFragment\n      }\n    }\n  }\n  id\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesList on Goal {\n  canEditUpdate\n  updateStreak\n  ...EmptyStateNoUpdates\n  updates(first: 30) {\n    edges {\n      node {\n        uuid\n        creationDate\n        ...EditableGoalUpdateCard\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment dropdownMenu on Goal {\n  accessLevel\n}\n\nfragment goalTypeName on GoalType {\n  name {\n    __typename\n    ... on GoalTypeCustomName {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment goalTypeNamePlural on GoalType {\n  ...goalTypeName\n  namePlural {\n    __typename\n    ... on GoalTypeCustomNamePlural {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment metricInfoSectionContent on Goal {\n  id\n  ...progressBarMetricTarget\n  ...hasMetric\n  ...MetricChart\n  ...ChangeRollupTypePopup\n  ...dropdownMenu\n  progress {\n    type\n    percentage\n  }\n  goalType {\n    successMeasure {\n      state\n      id\n      ...goalTypeName\n      ...goalTypeNamePlural\n    }\n    id\n    kind\n  }\n  subGoals {\n    edges {\n      node {\n        progress {\n          percentage\n        }\n        goalType {\n          kind\n          id\n        }\n        archived\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        progress {\n          percentage\n          type\n        }\n        archived\n        goalType {\n          ...goalTypeName\n          ...goalTypeNamePlural\n          id\n        }\n        id\n      }\n    }\n    pageInfo {\n      hasNextPage\n    }\n  }\n  parentGoal {\n    id\n    ari\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        ari\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          ari\n          archived\n          uuid\n          name\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useRollupSourceName on Goal {\n  progress {\n    type\n  }\n  successMeasureCount: successMeasures {\n    count\n  }\n  subGoals {\n    count\n  }\n  goalType {\n    successMeasure {\n      ...goalTypeName\n      ...goalTypeNamePlural\n      id\n    }\n    id\n  }\n}\n\nfragment useUserHasCapabilitiesFromGoal on Goal {\n  workspace {\n    currentUserAppCapabilities {\n      capabilities {\n        capability\n        capabilityContainer\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d673c847d6c203892e299aed928748ce";

export default node;
